import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import {DealerType} from '../Models/DealerType';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DealerTypeService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getDealerTypes() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/dealer-type/')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageDealerTypes(request: DealerType[]) {
    return this.http.put(environment.apiUrl + '/backoffice/dealer-type/',
      {dealerTypes: request})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

}
